module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pro/itemstransactions/itemstransactions-list/itemstransactions-list.component.scss
// module id = ./src/app/views/pro/itemstransactions/itemstransactions-list/itemstransactions-list.component.scss
// module chunks = main